import { Flex, Typography } from '@aloft/toolkit-sui';

const formatAlertBadgeCount = (count: number): string => (count > 9 ? '9+' : String(count));

export const SubNavAlertBadge = ({ count }: { count: number }) => (
  <Flex
    aria-hidden
    minWidth="16px"
    height="16px"
    paddingX="2px"
    borderRadius="50%"
    backgroundColor="statusOverdue"
    alignItems="center"
    justifyContent="center"
    flexShrink={0}
    __dangerDoNotUseSx={{ pointerEvents: 'none' }}
  >
    <Typography
      variant="subtitle3"
      color="textOffset"
      inline
      __dangerDoNotUseSx={{ fontSize: '12px', fontWeight: 800, lineHeight: 1 }}
    >
      {formatAlertBadgeCount(count)}
    </Typography>
  </Flex>
);
